const state = () => ({
    notifications: [],
});

let notificationSeq = 0;

const notificationGenerator = (type) => (notification) => {
    let duration = 3500;
    let text = null;
    let actionLabel = null;
    let onAction = null;
    if (typeof notification === "string") {
        text = notification;
    } else {
        text = notification.text;
        duration =
            notification.duration !== undefined
                ? notification.duration
                : duration;
        actionLabel = notification.actionLabel || null;
        onAction =
            typeof notification.onAction === "function"
                ? notification.onAction
                : null;
        if (actionLabel && notification.duration === undefined) {
            duration = 8000;
        }
    }
    return {
        id: ++notificationSeq,
        type,
        duration,
        text,
        actionLabel,
        onAction,
    };
};

const actions = {
    success({ commit }, notification) {
        commit(
            "addNotification",
            notificationGenerator("success")(notification),
        );
    },
    warning({ commit }, notification) {
        commit(
            "addNotification",
            notificationGenerator("warning")(notification),
        );
    },
    loading({ commit }, notification) {
        commit(
            "addNotification",
            notificationGenerator("loading")(notification),
        );
    },
    error({ commit }, notification) {
        commit(
            "addNotification",
            notificationGenerator("error")(notification),
        );
    },
    dismiss({ commit }, id) {
        commit("removeNotification", id);
    },
};

const mutations = {
    addNotification(state, notification) {
        state.notifications.push(notification);
    },
    removeNotification(state, id) {
        state.notifications = state.notifications.filter((n) => n.id !== id);
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
